import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import popupDrag from '../../static/image/popup_drag.png';
import '../../static/css/popup.css';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const BestMenuDrag = ({ items: propsItems, reset, onChange }) => {
  const [items, setItems] = useState([]);

  // propsItems 또는 reset이 변경될 때만 초기화
  useEffect(() => {
    const sortedItems = [...propsItems].sort(
      (a, b) => parseFloat(a.mainMenuVisibleIndex) - parseFloat(b.mainMenuVisibleIndex)
    );
    setItems(sortedItems);
  }, [propsItems, reset]);

  useEffect(() => {
    const closeBtnClickHandler = () => {
      $('.menuGrpPopup2').addClass('hide');
    };

    $('.menuGrpPopup2closeBtn').off('click').on('click', closeBtnClickHandler);

    return () => {
      $('.menuGrpPopup2closeBtn').off('click', closeBtnClickHandler);
    };
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const updatedItems = reorder(items, result.source.index, result.destination.index);

    // mainMenuVisibleIndex 재정렬
    const renumberedItems = updatedItems.map((item, idx) => ({
      ...item,
      mainMenuVisibleIndex: idx + 1
    }));

    setItems(renumberedItems);
    if (onChange) onChange(renumberedItems); // 부모에 전달
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <ul className='dragNumberBox'>
        {items.map((_, index) => (
          <li key={index}>{index + 1}</li>
        ))}
      </ul>

      <Droppable droppableId="menuGrpDragBox">
        {(provided) => (
          <ul
            className='popupDrag'
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {items.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={`item-${item.id}`}
                index={index}
              >
                {(provided) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <img
                      className='popupDragImg'
                      src={popupDrag}
                      alt="팝업드래그"
                    />
                    <div>
                      <p
                        className="popupDragTitle popupMenuGrpDragTitle"
                        data-id={item.id}
                      >
                        {item.name}
                      </p>
                    </div>
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default BestMenuDrag;
